<template>
    <div class="box">
      <div class="container" :class="noShowBg?'showbg':''">
        <div class="content" :class="noShowBg?'show-content':''">
          <div class="arow" @click="back()" ><img class="arow-img" src="@daoba-match/assets/sportsLogo/back.png" alt=""></div>
          <div class="middle">
            <div class="event">
              <div class="event-cont" v-for="(item,index) in newProgram" :key="index" @click="goEvent(item)" :class="(index+1%7)==0?'event-right':''">
                <a-avatar :size="80" :src="'https://static.daoba.com/sportsLogo/'+ item.programId + '.png'" :style="{ backgroundColor: '#ffffff00'}">
                  <div class="font-css" style="font-size:17px;padding:0;border: 3px solid white;">
                    {{item.program.substring(0,1)}}
                  </div>
                  </a-avatar>
                <div class="event-name">{{item.program}}</div>
              </div>
            </div>
          </div>
          <div class="arow" @click="next()" ><img class="arow-img" src="@daoba-match/assets/sportsLogo/next.png" alt=""></div>

        </div>
      </div>
    </div>
  </template>
<script>
export default {
  name: 'ProgramSwiper',
  props: {
    noShowBg: {
      type: Boolean,
      default:false
    },
    program:{
      type:Array,
      default:()=>{
        []
      }
    }
  },
  components: {},
  mounted () {
  },
  data () {
    return {
      index: 0,
    }
  },
  computed: {},
  methods: {

    goEvent (item) {
      this.$router.push({
        path: 'Project',
        query: {
          programId: item.programId
        }
      })

    },
    back () {
      if (this.index>0) {
          this.index--
      }
    },
    next () {
      if (this.program.length>(this.index+1)*14) {
        this.index++
      }
    },

  },
  computed:{
    newProgram(newVal,oldVal){
      if(this.program.length<14){
        return this.program
      }else{
        return this.program.slice(this.index*14,14*(this.index+1))
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .box{
    width: 100%;
    position: relative;
    top:-60px;
  }
  .container{
    width: 100%;
    height: 420px;
    background-image: url('../../../daoba-match/assets/weapon/playertopbg.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .showbg{
      background-image: none;
      height: 420px;
  }
  .content{
    width: 70%;
    height: 80%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: 70px;
  }
  .show-content{
      padding-top: 0;
  }
  .arow{
    width: 80px;
    height: 80px;
    z-index: 999;
  }
  .arow-img{
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .middle{
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content:flex-start ;
    flex-wrap: wrap;
    align-items: center;
    box-sizing: border-box;
  }
  .title{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: #FFF;
  }
  .title-main{
    display: flex;
    flex-direction: column;
    justify-content:center ;
    align-items: center;
    margin: 0 10px 10px 10px;
  }
  .title-main-cn{
    font-size: 22px;
  }
  .title-main-En{
    font-size: 14px;
  }
  .event{
    width: 100%;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    flex-wrap: wrap;
    height: 260px;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
  }
  .event-right{
    margin-right: 0;
  }
  .event-cont{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 150px;
    transition: .2s;
  }
  .event-cont:hover{
      transform:scale(1.2);
      cursor: pointer;
      transition: .2s;
      .event-name{
          font-weight: bold;
      }

  }
  .event-img{
    width: 55px;
    height: 55px;
  }
  .event-name{
    color: #FFF;
    font-size: 12px;
  }
  .font-css{
    width:45px;height:45px;font-weight:bold;line-height: 35px;border-radius:50%;color:white;
  }
  .event /deep/ .ant-avatar-string {
    line-height: 80px;
    transform: scale(1) translateX(-50%);
    opacity: 1 !important;
  }
  .slick{
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-70px);
      width: 140px;
      height: 40px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .dot{
          display: inline-block;
          width: 30px;
          height: 3px;
          border-radius: 3px;
          text-align: center;
          line-height: 20px;
          background-color: #fff;
          cursor: pointer;
      }
      .dot-active{
          transform: scale(1.3);
          background-color: #b01f23;
          cursor: pointer;
      }
  }
  </style>



// WEBPACK FOOTER //
// src/district/components/common/ProgramSwiper.vue